import React from "react";
import "./Compatibility.css";

export default function CompatibilityCard({ text }) {
  return (
    <div className="compat-card">
      <p>{text}</p>
    </div>
  );
}
